module.exports = __webpack_public_path__ + "img/default.96e01bb2.png";